import { createStore, applyMiddleware } from 'redux';
import { actions } from './actions';
import { ENVIRONMENT } from '@updater-core/lib/environment';

export function reducer(state = {}, { type, payload }) {
  switch (type) {
    case actions.SET_CURRENT:
    case actions.IS_TERMINAL_ROUTE:
      return { ...state, ...payload };
    case actions.GO_TO_NEXT:
      return {
        ...state,
        isTerminalRoute: false,
      };
    /*
       * replciate with upd store hookup
    case STATE_CHANGE_SUCCESS:
      return {
        ...state,
        isTerminalRoute: false,
      };
      */
    case actions.CLEAR_CURRENT:
      return {
        ...state,
        current: null,
      };
    case actions.SET_PERSONALIZED_STEPS:
      return {
        ...state,
        chosenSteps: payload.chosenSteps,
      };
    default:
      return state;
  }
}

export const createDaisyChainStore = () => {
  const logger = (store) => (next) => (action) => {
    const prevState = store.getState();
    next(action);
    const nextState = store.getState();
    try {
      /* eslint-disable no-console */
      console.log(
        `%c[DEBUG][DAISY-CHAIN][ACTION] - ${action.type} -`,
        'color: #ac2fa8',
        {
          action,
          prevState,
          nextState,
        }
      );
      /* eslint-enable */
    } catch (e) {} // eslint-disable-line no-empty
  };
  const middleware = [
    ...(ENVIRONMENT?.debug?.daisyChainInteractor ? [logger] : []),
  ];

  return applyMiddleware(...middleware)(createStore)(reducer, {
    isTerminalRoute: false,
    currentStep: null,
    chosenSteps: [],
  });
};
